var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fdd-add-sign-title"},[_c('a',{on:{"click":_vm.handleBack}},[_c('i',{staticClass:"use-return"}),_vm._v(_vm._s(_vm.title))]),(_vm.content)?_c('span',[_vm._v(_vm._s(_vm.content))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }